import type { Activity } from "@/entities/activity";

import { useReferentialModelUtils } from "@/entities/referential/referential-models";

export const useActivitySubjectType = () => {
  const { getModelFromClassPath } = useReferentialModelUtils();

  const getSubjectTypeName = (activity?: Activity) => {
    const subjectTypeFqcn = activity?.subject_type ?? "";
    const model = getModelFromClassPath(subjectTypeFqcn);
    return model?.name ?? "";
  };

  return {
    getSubjectTypeName,
  };
};
